export function heroAdaptiveBg() {
    let $parent = $(".has-video-container");
    let bg = $parent.find(".hero-bg");
    let videoBlock = $parent.find(".video-block");
    let videoHeight = 0;
    let videoIndent = 40;
    let logoBlockHeight = 0;
    let logoBlock = $parent.find(".raiting-block");
    let $win = $(window);

    let setBgHeight = function (video, logo) {
        if (video && logo) {

            let distance;
            videoHeight = $(video).height() / 2;
            logoBlockHeight = $(logo).height();

            if ($win.width() >= 1800) {
                videoIndent = 60;
            } else {
                videoIndent = 40;
            }

            distance = videoHeight + logoBlockHeight + videoIndent;

            $(bg).css({
                "height": "calc(100% - " + Math.round(distance) + "px)"
            })
        }
    };

    if ($win.width() >= 1024) {
        setBgHeight(videoBlock, logoBlock);
    }

    $win.on("resize", function() {
        if ($win.width() >= 1024) {
            setBgHeight(videoBlock, logoBlock);
        } else {
            $(bg).css({
                "height": "100%"
            })
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroAdaptiveBg.js